<template>
  <sv-kaledos />
  <div class="navigation">
    <div class="next-posts">
      <router-link to="/straipsniai/page/2"
        >« Naujesni įrašai</router-link
      >
    </div>
  </div>
</template>

<script>
import SvKaledos from './Articles/SvKaledos.vue'
export default {
  components: {
    SvKaledos
  }
}
</script>
